import { staticEntityReducerTemplate } from '../reducerUtils';

export default staticEntityReducerTemplate('universities');



// WEBPACK FOOTER //
// ./src/reducers/entities/universitiesReducer.js